import React from "react";
import {Col, Container, Image, Row} from "react-bootstrap";
import dc_utilisation from "../assets/img/data-center.png";
import LocalLoops from "../assets/img/local-area.png";
import CrossConnect from "../assets/img/cloud-network.png";

const SectionSeven = () => {
  return (
    <div id="id_data" className="enterprise-messaging-section">
      <Col lg={7} className="mx-auto text-center overflow-hidden">
        <div className="overflow-hidden">
          <Col lg={7} className="mx-auto text-center overflow-hidden">
            <p className="mx-2 px-2 mb-5 display-5 fw-normal">
              <strong className="gradient-text">DATA</strong> <br />
            </p>
            <p className="gradient-text" style={{ fontSize : "large", fontWeight : "bolder"}}>Flexible connectivity and infrastructure built for scale</p>

          </Col>
        </div>
      </Col>
      <section className="sf-section-four">
        <Container>
          <Row className="sf-overlap">
            <Col xs={12} md={4} className="mb-4">
              <div className="sf-frame" style={{ background: "#f8f5fd00" }}>
                <Image className="sf-img" src={CrossConnect} fluid />
                <div className="sf-text-wrapper">Cross Connect</div>
                <p className="sf-p">
                  Secure and efficient interconnection
                  services within and across data
                  centre environments, enabling
                  seamless connectivity between
                  networks, platforms, and partners.
                </p>
                {/*  <div className="sf-cta">*/}
                {/*    <Button*/}
                {/*        onClick={() => navigate("/contact")}*/}
                {/*        className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
                {/*    >*/}
                {/*      Contact Us*/}
                {/*    </Button>*/}
                {/*</div>*/}

              </div>
            </Col>
            <Col xs={12} md={4} className="mb-4">
              <div className="sf-frame" style={{ background: "#f8f5fd00" }}>
                <Image className="sf-img" src={LocalLoops} fluid />
                <div className="sf-text-wrapper">Local Loops</div>
                <p className="sf-p">
                  Dedicated last-mile connectivity
                  solutions that support reliable
                  access between customer sites,
                  operator infrast
                </p>
                {/*<div className="sf-cta">*/}
                {/*  <Button*/}
                {/*      onClick={() => navigate("/contact")}*/}
                {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
                {/*  >*/}
                {/*    Contact Us*/}
                {/*  </Button>*/}
                {/*</div>*/}
              </div>
            </Col>
            <Col xs={12} md={4} className="mb-4">
              <div className="sf-frame-2" style={{ background: "#f8f5fd00" }}>
                <Image className="sf-group-2" src={dc_utilisation} fluid />
                <div className="sf-text-wrapper">Data Center Utilisation</div>
                <p className="sf-p">
                  Flexible infrastructure and capacity
                  solutions that help partners
                  optimise data centre presence,
                  improve resource efficiency, and
                  support scalable service delivery.
                </p>
                {/*<div className="sf-cta">*/}
                {/*  <Button*/}
                {/*      onClick={() => navigate("/contact")}*/}
                {/*      className="navbar-contact-us-btn btn d-inline-block btn-primary"*/}
                {/*  >*/}
                {/*    Contact Us*/}
                {/*  </Button>*/}
                {/*</div>*/}
              </div>
            </Col>
            {/*<Col xs={12} md={6} className="mb-4">*/}
            {/*  <div className="sf-frame-2">*/}
            {/*    <Image className="sf-group-2" src={MNPImage} fluid />*/}
            {/*    <div className="sf-text-wrapper">Mobile Number Portability</div>*/}
            {/*    <p className="sf-p">*/}
            {/*      With our MNP service, enterprises can ensure a 100% SMS delivery*/}
            {/*      rate, eliminate message failures, and provide an exceptional*/}
            {/*      customer experience.*/}
            {/*    </p>*/}
            {/*  </div>*/}
            {/*</Col>*/}
          </Row>
        </Container>
        {/*<div className="sf-dots-image-container">*/}
        {/*  <div id="products" className="dot-background">*/}

        {/*  </div>*/}
        {/*</div>*/}
      </section>
    </div>


  );
};

export default SectionSeven;
